<label>{{ 'reward.status.not.enough.points' | translate }}</label>
